'use client';

import BookDemoButtonComponent, { IProps } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModal/BookDemoButton';
import config from '@allocate/config';
import { LogoAllocateStandart } from '@dealroadshow/uikit-logo/Allocate/Standart';

const BookDemoButton = (props: Omit<IProps, 'tenant'>) => (
  <BookDemoButtonComponent
    tenant={ config.code }
    logoComponent={ LogoAllocateStandart }
    { ...props }
  />
);

export default BookDemoButton;
